import { render, staticRenderFns } from "./modal-delete-account.vue?vue&type=template&id=fb7ec610&scoped=true&"
import script from "./modal-delete-account.vue?vue&type=script&lang=js&"
export * from "./modal-delete-account.vue?vue&type=script&lang=js&"
import style0 from "./modal-delete-account.vue?vue&type=style&index=0&id=fb7ec610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7ec610",
  null
  
)

export default component.exports